import mitt from 'mitt';
export var ProfileEventTypes;
(function (ProfileEventTypes) {
    ProfileEventTypes["LOGIN_INITIATED"] = "loginInitiated";
    ProfileEventTypes["LOGIN_COMPLETED"] = "loginCompleted";
    ProfileEventTypes["LOGIN_FAILED"] = "loginFailed";
    ProfileEventTypes["MERGE_INITIATED"] = "mergeInitiated";
    ProfileEventTypes["MERGE_COMPLETED"] = "mergeCompleted";
    ProfileEventTypes["MERGE_FAILED"] = "mergeFailed";
})(ProfileEventTypes || (ProfileEventTypes = {}));
export var ProfileEvents;
(function (ProfileEvents) {
    ProfileEvents["ProfileEvent"] = "profileEvent";
})(ProfileEvents || (ProfileEvents = {}));
const eventEmitter = mitt();
/** Emit a profile event. Used internally by profile components. */
export function emitProfileEvent(event) {
    eventEmitter.emit(ProfileEvents.ProfileEvent, event);
}
/** Subscribe/unsubscribe surface for host apps (e.g. analytics). */
export const profileEventEmitter = {
    on: eventEmitter.on,
    off: eventEmitter.off,
};
